import { Base } from "./Base";

export interface Class extends Base {
  classCode: number;
  className: string;
  gradeId: number;
  gradeName: string;
}

export const initClass: Class = {
  id: -1,
  key: -1,
  classCode: -1,
  className: "",
  gradeId: -1,
  gradeName: "",
};
